export const AUTH_SIGNUP_REQUEST = "AUTH_SIGNUP_REQUEST";
export const AUTH_SIGNUP_SUCCESS = "AUTH_SIGNUP_SUCCESS";
export const AUTH_SIGNUP_FAIL = "AUTH_SIGNUP_FAIL";
export const AUTH_SIGNUP_RESET = "AUTH_SIGNUP_RESET";

export const AUTH_SIGNIN_REQUEST = "AUTH_SIGNIN_REQUEST";
export const AUTH_SIGNIN_SUCCESS = "AUTH_SIGNIN_SUCCESS";
export const AUTH_SIGNIN_FAIL = "AUTH_SIGNIN_FAIL";

export const AUTH_PAYMENT_METHOD_REQUEST = "AUTH_PAYMENT_METHOD_REQUEST";
export const AUTH_PAYMENT_METHOD_SUCCESS = "AUTH_PAYMENT_METHOD_SUCCESS";
export const AUTH_PAYMENT_METHOD_FAIL = "AUTH_PAYMENT_METHOD_FAIL";
export const AUTH_PAYMENT_METHOD_RESET = "AUTH_PAYMENT_METHOD_RESET";
